import axios from "axios";
import Config from "../Config";
export default {
  init: (param, headerOption) =>
    axios.post(`${Config.API_DOMAIN}/ext/auth/external/v1/authorize`, param, {
      headers: headerOption,
      timeout: 5000
    }),
  login: (id_type, param, headerOption) =>
    axios.post(`${Config.API_DOMAIN}/ext/auth/external/v1/signin/${id_type}`, param, {
      headers: headerOption
    }),
  createToken: (param, headerOption) =>
    axios.post(`${Config.API_DOMAIN}/ext/auth/external/v1/token/create`, param, {
      headers: headerOption
    }),
  refreshToken: (param, headerOption) =>
    axios.post(`${Config.API_DOMAIN}/ext/auth/external/v1/token/refresh`, param, {
      headers: headerOption
    }),
  validToken: (headerOption) =>
    axios.get(`${Config.API_DOMAIN}/ext/auth/external/v1/token/verify`, {
      headers: headerOption
    }),
  verifyZocboToken: (headerOption) =>
    axios.get(`${Config.API_DOMAIN}/ext/auth/external/v1/zocbo/token/verify`, {
      headers: headerOption
    }),
  ssoSignin: (id_type, param, headerOption) =>
    axios.post(`${Config.API_DOMAIN}/ext/auth/external/v1/sso/signin/direct/account`, param, {
      headers: headerOption
    }),
  ssoCreateToken: (param, headerOption) =>
    axios.post(`${Config.API_DOMAIN}/ext/auth/external/v1/sso/token/create`, param, {
      headers: headerOption
    }),
  localCreateToken: (param, headerOption) =>
    axios.post(`${Config.API_DOMAIN}/ext/auth/external/v1/local/token/create`, param, {
      headers: headerOption
    }),
  transferAccountCertify(service_id, id_type, param, headerOption) {
    return axios.post(`${Config.API_DOMAIN}/ext/auth/external/v1/signin/transfer/${service_id}/${id_type}`, param, {
      headers: headerOption
    });
  },
  logout(headerOption, param) {
    return axios.post(`${Config.API_DOMAIN}/ext/auth/external/v1/logout`, param, {
      headers: headerOption
    });
  },
  //cors 우회하기 위하여(서버에서 처리 안됨) jsonp 타입의 ajax 사용 (axios 는 jsonp 지원 안함)
  createEtoosCookie: (url, param) => {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-unused-vars
      $.ajaxPrefilter("json", function (options, orig, jqXHR) {
        return "jsonp";
      });
      $.ajax({
        type: "get",
        crossDomain: true,
        url,
        data: param,
        async: false,
        dataType: "jsonp",
        jsonpCallback: "callback",
        success: (res) => resolve(res),
        error: (e) => reject(e)
      });
    });
  },
  removeEtoosCookies(urls) {
    const promises = [];
    Array.from(urls).forEach((url) => {
      promises.push(this.getPromise(url));
    });
    return Promise.allSettled(promises);
  },
  getPromise: (url) => {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-unused-vars
      $.ajaxPrefilter("json", function (options, orig, jqXHR) {
        return "jsonp";
      });
      $.ajax({
        crossDomain: true,
        url,
        async: false,
        dataType: "jsonp",
        jsonpCallback: "callback",
        success: () => resolve(),
        error: () => reject()
      });
    });
  },
  etoosMobileWebSignAPi: (param, headerOption) => {
    return axios.post(`${Config.API_DOMAIN}/ext/auth/external/v1/etoos/v1/mobileweb/signin`, param, {
      headers: headerOption
    });
  }
};
